import { render, staticRenderFns } from "./auditJournal.vue?vue&type=template&id=37031df0"
import script from "./auditJournal.vue?vue&type=script&lang=ts"
export * from "./auditJournal.vue?vue&type=script&lang=ts"
import style0 from "./auditJournal.vue?vue&type=style&index=0&id=37031df0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports